<template>
  <div class="home">
    <F-Header/>
    <div class="infoList_wrapper">
      <!-- 内容 -->
      <div class="main">
        <div class="cont">
          <div class="cont_tit">
            <div class="left_bar">
              <h2><p class="span-a">{{ orgType }} <i/><span>{{ orgName }}</span></p></h2>
            </div>
            <div class="right_bar">
              <span>年度 : </span>
              <a-select default-value="2016" style="width: 120px" @change="loadData" size="small" v-model="form.year">
                <a-select-option :value="item.value" v-for="item in options.years">{{ item.label }}</a-select-option>
              </a-select>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="cont_area" style="padding: 20px">
            <a-radio-group class="card-type-parent" button-style="solid" @change="loadData" v-model="form.dataType">
              <template v-if="isZsq">
                <a-radio-button class="card-type-zsq" :value="item.type" v-for="item in options.dataType">
                  {{ item.name }}
                </a-radio-button>
              </template>
              <template v-else>
                <a-radio-button class="card-type" :value="item.type" v-for="item in options.dataType">
                  {{ item.name }}
                </a-radio-button>
              </template>
            </a-radio-group>

            <div class="clearfix"></div>
            <div class="cont_box">
				<template v-if="dataList!=null&&dataList.length>0">
				<div style="font-size: 25px;color: #000;margin: 10px 0" v-for="item in dataList">
	                <p v-if="item&&item.wordFile&&item.wordFile.uploadName">
	                  <a class="intro-a" @click="viewPdf(item.wordFile)" style="font-size: 14px">
	                    <a class="intro-a" style="color:#306287FF;font-weight: 500;font-size: 14px">{{ item.year }}年度-</a>
	                    {{ item.wordFile.uploadName.replace('.pdf', '') }}</a>
	                  <span>{{ item.publishTime }}</span>
	                </p>
	                <p v-if="item&&item.wordFile2&&item.wordFile2.uploadName">
	                  <a class="intro-a" @click="viewPdf(item.wordFile2)" style="font-size: 14px">
	                    <a class="intro-a" style="color:#306287FF;font-weight: 500;font-size: 14px">{{ item.year }}年度-</a>
	                    {{ item.wordFile2.uploadName.replace('.pdf', '') }}
	                    </a>
	                  <span>{{ item.publishTime }}</span>
	                </p>
	                <p v-for="excel in item.excelFileList">
	                  <a class="intro-a" @click="viewExcel(excel)" style="font-size: 14px">
	                    <a class="intro-a" style="color:#306287FF;font-weight: 500;font-size: 14px">{{ item.year }}年度-</a>
	                    {{ excel.customName.replace('.xlsx', '') }}</a>
	                  <span>{{ item.publishTime }}</span>
	                </p>
            	</div>
            	</template>
				<template v-else>
				<div style="font-size: 18px;color: rgba(0, 0, 0,0.5);margin: 0;text-align: center;
					height: 100px;line-height: 100px;">
	                	未公开
            	</div>
				</template>
            </div>
            <div class="page-action">
              <a-pagination :total="form.dataCount" :page-size="form.pageSize" show-size-changer size="small"
                            :page-size-options="options.pageSizeOptions" @showSizeChange="onShowSizeChange">
                <template slot="buildOptionText" slot-scope="props">
                  <span>{{ props.value }}条/页</span>
                </template>
              </a-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="push"></div>
    </div>
    <F-Footer/>

  </div>
</template>

<script>
// @ is an alias to /src
import {CustomOpenApis as api} from "@/api/CustomApis";
import FHeader from "@/views/portal/F-Header";
import FFooter from "@/views/portal/F-Footer";
import {getYears,defaultYear} from "@/utils/years.js";

export default {
  name: 'Home',
  components: {FHeader, FFooter},
  watch: {
    isZsq: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.options.dataType = this.options.dataTypeOptions['zsq']
        } else {
          this.options.dataType = this.options.dataTypeOptions['default']
        }
      }
    }
  },
  data() {
    return {
      orgType: '',
      orgName: '',
      options: {
        years: getYears(),
        dataType: [],
        dataTypeOptions: {
          default: [
            {name: '部门预算表', type: 0},
            {name: '部门决算表', type: 1},
            {name: '预算绩效目标', type: 2},
            {name: '决算绩效评价', type: 3},
          ],
          zsq: [
            {name: '部门预算表', type: 0},
            {name:'预算调整',type:6},
            {name: '部门决算表', type: 1},
            {name: '预算绩效目标', type: 2},
            {name: '决算绩效评价', type: 3},
            //{name: '批复文件', type: 4},
            //{name: '政府债务公开', type: 5},
          ]
        },

        pageSizeOptions: ['10', '20', '30', '40', '50'],
      },
      form: {
        dataType: 0,
        year: defaultYear(),
        regionId: null,
        governId: null,
        pageSize: 10,
        pageIndex: 0,
        dataCount: 0,
      },
      dataList: [],
      isZsq: null,
    }
  },
  mounted() {
    this.isZsq = false
    this.loadArea()
    this.loadData()
  },
  methods: {
    viewPdf(pdf) {
      window.open(`/pdfjs/web/viewer.html?file=${encodeURIComponent(pdf.path)}`);
    },
    viewWord(word) {
      let fileUrl = 'http://zsqyjsgs.arovane.cn' + word.path
      let url = 'https://view.officeapps.live.com/op/view.aspx?src=' + fileUrl
      window.open(url, '_blank');
    },
    viewExcel(excel) {
      console.log(excel)
      let routeData = this.$router.resolve({
        path: '/view-excel',
        query: {path: excel.path}
      });
      window.open(routeData.href, '_blank');
    },
    onShowSizeChange(current, pageSize) {
      this.form.pageIndex = current;
      this.form.pageSize = pageSize;
      this.loadData()
    },
    loadArea() {
      this.form.regionId = this.$route.query.id
      this.$http.get(`${api.getRegById}/${this.form.regionId}`).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message)
          return
        }
        this.orgName = result.data.simpleName
        if (this.orgName === '钟山区') {
          this.isZsq = true
        }
        this.form.governId = result.data.governId
        this.$http.get(`${api.getGovById}/${this.form.governId}`).then(result => {
          if (result.status !== 200) {
            this.$message.error(result.message)
            return
          }
          this.orgType = result.data.name
        })
      })
    },
    loadData() {
      let searchParams = {
        year: this.form.year,
        dataType: this.form.dataType,
        regionId: this.form.regionId
      }
      let pageParam = `pageIndex=${this.form.pageIndex}&pageSize=${this.form.pageSize}`
      this.$http.post(`${api.searchPublish}?${pageParam}`, searchParams).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message)
          return
        }
        this.dataList = result.data
        this.form.dataCount = result.page.dataCount
      })
    },
  }
}
</script>
<style scoped>
@import "~@public/reset.css";
@import "~@public/infoShow.css";

.intro-a {
  font-size: 18px;
  color: #000;
  cursor: pointer;
}

.intro-a :hover {
  background-color: lightcyan;
  cursor: pointer;
}

.card-type-parent {
  margin-top: 16px;
  width: 100%;
}

.card-type {
  font-size: 16px;
  width: 25%;
  text-align: center;
}

.card-type-zsq {
  font-size: 16px;
  //width: 14.2%;
  width: 20%;
  text-align: center;
}

.main {
  background: #f5f5fa;
}

.span-a {
  font-size: 1em;
  color: #c6121d;
}

.page-action {
  /*border: 1px solid red;*/
  text-align: right;
}

.cont_area {
  padding: 20px;
}
</style>
